import Swiper from 'swiper/dist/js/swiper.min.js';
import Swiper2 from 'swiper/dist/js/swiper.min.js';
import 'readmore-js';
import 'magnific-popup/dist/jquery.magnific-popup.min.js';

let scrollTimeout2;
let slider_bar_swiper = null;
let userClickedSlider2 = false;

jQuery(document).ready(function ($) {
    if (!$('.anchor-nav').length) {
        return;
    }
    SwiperNavAnchor($);
    anchorSliderDesktop($);
    AddReadMore();
    $('.anchor-nav .text-with-image .less-text').addClass('addReadMore showlesscontent');


    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com',
                    id: 'v=',
                    src: 'https://www.youtube.com/embed/%id%?rel=0&mute=0',
                },
            },
        },
    });

});

function anchorSliderDesktop($) {

    // If url contains hash, show the tab referenced as tab
    // if (window.location.hash && $(`.slider-bar[href="${window.location.hash}"]`).length) {
    //     setTimeout(() => {
    //         let slider_bar = $(`.slider-bar[href="${window.location.hash}"]`);
    //         // let aid = window.location.hash;
    //         // let offset = $('.header').outerHeight() + $('.slider-tabs').outerHeight() + 89;

    //         setActiveSliderBar2(slider_bar);
    //         // $('html,body').animate({ scrollTop: $(aid).offset().top - offset },
    //         //     'slow'
    //         // );
    //     }, 1);
    // } else {
    //     setActiveSliderBarForScroll2();
    // }

    calcFixedSlider2();
    setActiveSliderBarForScroll2();

    $('.slider-bar').on('click', function () {
        userClickedSlider2 = true;
        setActiveSliderBar2(this);
    })

    $('.slider-bar').click(function (e) {
        e.preventDefault();
        var aid = $(this).attr('href');
        // var offset = $('.header').outerHeight() + $('.slider-tabs').outerHeight() + 89;
        $('html,body').animate({ scrollTop: $(aid).offset().top - 89 },
            'slow'
        );
    });

    $(window).scroll(function () {
        calcFixedSlider2();
        setActiveSliderBarForScrollTO2();
    });

    if ($('.slider-categories').length) {
        $('.slider-category').on('click', function (e) {
            e.preventDefault();

            let parent_el = $(this).closest('.anchor-nav');
            $(parent_el).find('.slider-category').removeClass('active').addClass('hide');
            $(this).addClass('active').removeClass('hide');
            $(parent_el).find('.slider-list-categories').addClass('active');

            showHideResetBtn(parent_el);
            showHideSlides(parent_el);

            $(parent_el).find('.slider-categories-container')[0].swiper.params.slidesOffsetAfter = 0;
            $(parent_el).find('.slider-categories-container')[0].swiper.params.slidesOffsetBefore = 0;
            $(parent_el).find('.slider-categories-container')[0].swiper.update();
        });

        $('.btn-reset-categories').on('click', function (e) {
            e.preventDefault();

            let parent_el = $(this).closest('.anchor-nav');
            $(parent_el).find('.slider-category').removeClass('active hide');
            $(parent_el).find('.slider-list-categories').removeClass('active');

            showHideResetBtn(parent_el);
            showHideSlides(parent_el);

            if ($(window).width() <= 767) {
                $(parent_el).find('.slider-categories-container')[0].swiper.params.slidesOffsetAfter = 150;
                $(parent_el).find('.slider-categories-container')[0].swiper.params.slidesOffsetBefore = 30;
                $(parent_el).find('.slider-categories-container')[0].swiper.update();
            }
        })
    }
}

function showHideSlides(parent_el) {
    let active_cats = [];

    $(parent_el).find('.slider-category.active').each(function () {
        active_cats.push($(this).data('cat'));
    });

    if (active_cats.length) {
        $(parent_el).find('.slider-bar').each(function () {
            let el_cats = $(this).data('cats').split(',');
            if (!el_cats.some(r => active_cats.includes(r))) {
                $(this).addClass('hide');
            } else {
                $(this).removeClass('hide');
            }
        });

        $(parent_el).find('.slider-content').each(function () {
            let el_cats = $(this).data('cats').split(',');
            if (!el_cats.some(r => active_cats.includes(r))) {
                $(this).addClass('hide');
            } else {
                $(this).removeClass('hide');
            }
        });
    } else {
        $(parent_el).find('.slider-bar, .slider-content').removeClass('hide');
    }

    $('.slider-content:not(.hide)').each(function (index) {
        if (index % 2 == 1) {
            $(this).addClass('reverse-row');
            $(this).find('.grid-row').addClass('reverse-row');
        } else {
            $(this).removeClass('reverse-row');
            $(this).find('.grid-row').removeClass('reverse-row');
        }
    });

    let slider_bar = $(parent_el).find('.slider-bar:not(.hide)').first();
    setActiveSliderBar2(slider_bar);

    if ($(parent_el).find('.slider-bar:not(.hide)').length == 1 || ($(window).width() > 767)) {
        $(parent_el).find('.slider-bar-container')[0].swiper.params.slidesOffsetAfter = 0;
        $(parent_el).find('.slider-bar-container')[0].swiper.params.slidesOffsetBefore = 0;
        $(parent_el).find('.slider-bar-container')[0].swiper.update();
    } else {
        $(parent_el).find('.slider-bar-container')[0].swiper.params.slidesOffsetAfter = 100;
        $(parent_el).find('.slider-bar-container')[0].swiper.params.slidesOffsetBefore = 30;
        $(parent_el).find('.slider-bar-container')[0].swiper.update();
    }

    setTimeout(() => {
        $(parent_el).find('.slider-bar-container')[0].swiper.update();
        $(parent_el).find('.slider-bar-container')[0].swiper.slideReset();

        $(parent_el).find('.slider-categories-container')[0].swiper.update();
        $(parent_el).find('.slider-categories-container')[0].swiper.slideReset();

        if ($('html, body').scrollTop() > $('.anchor-nav').offset().top) {
            $('html, body').animate({ scrollTop: $('.anchor-nav').offset().top - $('.header').outerHeight() }, { duration: 500 });
        }
    }, 100);
}

function showHideResetBtn(parent_el) {
    if (parent_el.find('.slider-category.active').length) {
        parent_el.find('.btn-reset-categories').removeClass('hide');
    } else {
        parent_el.find('.btn-reset-categories').addClass('hide');
    }
}

function calcFixedSlider2() {
    const scroll = $(window).scrollTop();
    const triggerPoint = $('.anchor-nav').offset().top
        //- $('#wpadminbar').outerHeight()
        -
        $('.header').outerHeight();
    const contentHeight = $('.anchor-nav').offset().top + $('.anchor-nav').outerHeight() - $('.header').outerHeight();

    if (scroll > triggerPoint && scroll < contentHeight) {
        $('.slider-tabs').addClass('fixed');

        if ($('.slider-categories').length) {
            $('.slider-categories').addClass('fixed');
        }
    } else {
        $('.slider-tabs').removeClass('fixed');

        if ($('.slider-categories').length) {
            $('.slider-categories').removeClass('fixed');
        }
    }
}

function setActiveSliderBarForScrollTO2() {
    clearTimeout(scrollTimeout2);
    scrollTimeout2 = setTimeout(function () {
        setActiveSliderBarForScroll2();
    }, 100); //Timeout needed to establish the exact location after scrolling
}

// This function calculates the block which is currently displayed.
// At the same time the function counts the block-anchors up to the currently displayed block.
// These blocks are represented as a tab in the slider bar, so the number of block-anchors
// is the index of the highlighted tab in the slider bar.
function setActiveSliderBarForScroll2() {
    if (userClickedSlider2) // There is no need to recalculate after slider-bar was clicked
    {
        userClickedSlider2 = false;
        return;
    }
    //const yOffset = $(window).scrollTop() + $('.slider-bar-container').height() + $('#wpadminbar').outerHeight();
    const yOffset = $(window).scrollTop() + $('.slider-tabs').outerHeight() + $('.header').outerHeight() + 89;
    let anchorIndex = -1;
    $('.slider-content').each(function () {
        if ($(this).find('.block-anchor').length > 0 || $(this).hasClass('block-anchor')) {
            anchorIndex++;
        }
        if ($(this).offset().top + $(this).outerHeight() > yOffset) {
            $('.slider-content').removeClass('current');
            $(this).addClass('current');
            // anchorIndex represents the correct index in the slider bar including cases when
            // the current block is not an anchor block.
            if (anchorIndex < 0) { // for cases when the current block is before the first anchor
                anchorIndex = 0;
            }
            setActiveSliderBar2($('.slider-bar').eq(anchorIndex));
            return false; // stops the iteration after the apropriate block identified
        }
    });
}


function setActiveSliderBar2(activeEl) {
    let tab = '';
    $('.slider-bar').removeClass('active');
    if (activeEl) {
        $(activeEl).addClass('active');

        $('.slider-bar .bottom-line').removeClass('tab-' + index);
        let index = $('.slider-bar').index(activeEl);
        tab = 'tab-' + index;

        history.pushState(null, null, $(activeEl).attr('href'));
        if (slider_bar_swiper) {
            // slider_bar_swiper.slideTo(index, 500);
        }
    }
    $('.slider-bar .bottom-line').addClass(tab);

    // let slider_bar_container = document.querySelector('.slider-bar-container');
    // let slide_active_left = document.querySelector('.slider-bar.active') ? document.querySelector('.slider-bar.active').offsetLeft : 0;
    // if (slider_bar_container.scrollWidth > slider_bar_container.clientWidth) {
    //     $('.slider-bar-container').animate({ scrollLeft: slide_active_left }, 500);
    // }

}

function AddReadMore() {
    jQuery('.anchor-nav .text-with-image .less-text').each(function () {
        let element_text_p = jQuery(this).find('p:first');
        let collapsed_height = 148;

        if (element_text_p.length) {
            element_text_p = element_text_p.get(0);
            collapsed_height = 4 * getLineHeight(element_text_p) + 20;

            if (element_text_p.clientHeight < collapsed_height) {
                collapsed_height = element_text_p.clientHeight + 20;
            }
        }

        jQuery(this).readmore({
            moreLink: '<a href="#">' + window['binah'].translate.more_info + '</a>',
            lessLink: '<a href="#">' + window['binah'].translate.close + '</a>',
            collapsedHeight: collapsed_height,
            speed: 300,
            afterToggle: function (trigger, element, expanded) {
                if (!expanded) {
                    // The "Close" link was clicked
                    var offset = jQuery('.header').outerHeight() + jQuery('.slider-tabs').outerHeight() + 89;
                    jQuery('html, body').animate({ scrollTop: element.offset().top - offset }, { duration: 500 });

                }
            },
        });
    })
}

function getLineHeight(el) {
    var temp = document.createElement(el.nodeName),
        ret;
    temp.setAttribute('style', 'margin:0; padding:0; ' +
        'font-family:' + (el.style.fontFamily || 'inherit') + '; ' +
        'font-size:' + (el.style.fontSize || 'inherit'));
    temp.innerHTML = 'A';

    el.parentNode.appendChild(temp);
    ret = temp.clientHeight;
    temp.parentNode.removeChild(temp);

    return ret;
}

function SwiperNavAnchor($) {
    //document.querySelectorAll('.swiper').forEach(function (s) {
    if ($('.anchor-nav .slider-bar').length > 1) {
        slider_bar_swiper = new Swiper('.slider-bar-container', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            slidesOffsetAfter: 100,
            slidesOffsetBefore: 30,
            navigation: {
                nextEl: '.slider-bar-next-button',
                prevEl: '.slider-bar-prev-button',
            },
            breakpoints: {
                767: {
                    slidesOffsetAfter: 100,
                    slidesOffsetBefore: 30,
                },
            },
        })
    }

    if ($('.anchor-nav .slider-category').length > 1) {
        new Swiper2('.slider-categories-container', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            // slidesOffsetAfter: 100,
            // slidesOffsetBefore: 10,
            navigation: {
                nextEl: '.slider-cat-next-button',
                prevEl: '.slider-cat-prev-button',
            },
            breakpoints: {
                767: {
                    slidesOffsetAfter: 150,
                    slidesOffsetBefore: 30,
                },
            },
        })
    }

    //});
}



// WEBPACK FOOTER //
// ./scripts/blocks/anchor-nav.js